import React from "react";
import { ViewType } from "components/appointments/useAppointmentView";
import { isEmpty, find, compact } from "lodash";
import { Calendar } from "../../@types/appointments";
import { useParams } from "helpers/tixxt-router";
import { useSelector } from "react-redux";
import { State } from "../../@types";
import ToolBar from "components/appointments/toolbars/ToolBar";
import MobileAppToolBar from "components/appointments/toolbars/MobileAppToolBar";

type AppointmentToolbarArgs = {
  isLoading: boolean;
  view?: ViewType;
  setViewType?: (viewType: ViewType) => void;
  date: string;
  setDate: (date: string) => void;
  calendars?: Calendar[];
  toggleExcludedCalendarIds?: (calendarId: string) => void;
  excludedCalendarIds?: string[];
  scrollToToday?: () => void;
  canCreate?: boolean;
  hideActions?: boolean;
};

export default function AppointmentToolbar({
  isLoading,
  view,
  setViewType,
  date,
  setDate,
  calendars,
  toggleExcludedCalendarIds,
  excludedCalendarIds,
  canCreate = false,
  scrollToToday,
  hideActions,
}: AppointmentToolbarArgs) {
  const { groupSlug } = useParams();
  const group = useSelector((state: State) =>
    groupSlug ? state.groups.bySlug?.[groupSlug] : null,
  );
  const calendarId = !isEmpty(group)
    ? find(
        compact(calendars),
        (cal) =>
          cal.type === "group" &&
          cal.parent_id === group?.id &&
          cal.can.create_appointments,
      )?.id
    : undefined;

  const ToolBarComponent = window.isApp ? MobileAppToolBar : ToolBar;

  return (
    <ToolBarComponent
      {...{
        date,
        setDate,
        scrollToToday,
        canCreate,
        hideActions,
        calendarId,
        isLoading,
        view,
        setViewType,
        calendars,
        toggleExcludedCalendarIds,
        excludedCalendarIds,
      }}
    />
  );
}
